import React from 'react';

export function extractMarkdownTableData(children: React.ReactNode) {
  const headers: React.ReactNode[] = [];
  const rows: Record<string, React.ReactNode>[] = [];

  React.Children.forEach(children, (child) => {
    if (!React.isValidElement(child)) return;
    if (child.type === 'thead') {
      React.Children.forEach((child.props as any).children, (tr: any) => {
        if (!React.isValidElement(tr)) return;
        React.Children.forEach((tr.props as any).children, (th: any) => {
          if (!React.isValidElement(th)) return;
          headers.push((th.props as any).children);
        });
      });
    }
    if (child.type === 'tbody') {
      React.Children.forEach((child.props as any).children, (tr: any) => {
        if (!React.isValidElement(tr)) return;
        const row: Record<string, React.ReactNode> = {};
        let colIndex = 0;
        React.Children.forEach((tr.props as any).children, (td: any) => {
          if (!React.isValidElement(td)) return;
          row[`col${colIndex}`] = (td.props as any).children;
          colIndex++;
        });
        rows.push(row);
      });
    }
  });

  return {
    columns: headers.map((header, index) => ({
      field: `col${index}`,
      header,
      render: (value: React.ReactNode) => value,
    })),
    data: rows,
  };
}
